import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { UsersApi, type AddUserAccountsRequest, type UserProfileResponse } from '@shared/api';

const addUserAccountsEffect = createEffect((request: AddUserAccountsRequest) => UsersApi.addUserAccounts(request));
const clearEvent = createEvent();

const $dataStore = createStore<UserProfileResponse | null>(null)
  .on(addUserAccountsEffect.done, (current, data) => data.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(addUserAccountsEffect.pending, (_, data) => data)
  .on(addUserAccountsEffect.fail, () => false)
  .on(addUserAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(addUserAccountsEffect, () => null)
  // .on(addUserAccountsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(addUserAccountsEffect.fail, () => 'Something went wrong while adding Manager. Please try again.')
  .on(addUserAccountsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $addUserAccountsStore = {
  events: {
    addUserAccounts: addUserAccountsEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
